var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoJira = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.415 1H7.668a3.046 3.046 0 0 0 3.042 3.042h1.248v1.19A3.046 3.046 0 0 0 15 8.272V1.585A.587.587 0 0 0 14.415 1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.08 4.354H4.335a3.046 3.046 0 0 0 3.042 3.042h1.248v1.208a3.046 3.046 0 0 0 3.042 3.042V4.958a.604.604 0 0 0-.585-.604"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.747 7.708H1a3.046 3.046 0 0 0 3.042 3.041H5.27v1.19a3.046 3.046 0 0 0 3.042 3.041V8.273c.02-.292-.253-.565-.565-.565"
})));
export default SvgLogoJira;